import type { MatchOperationsEvent } from '@y-sports/api-client';

export const broadcastTeamOrder = (sidesSwapped = false): [number, number] => sidesSwapped ? [1, 0] : [0, 1];

export const isBroadcastPath = (path: string) => /^\/(?:stream-overlay\/[^/]+|overlay\/matches\/[^/]+)\/?$/.test(path);
export const isBroadcastPopupKind = (kind: string) => ['GOAL', 'PENALTY_GOAL', 'TEAM_TIMEOUT', 'PENALTY_2MIN', 'YELLOW_CARD', 'RED_CARD', 'BLUE_CARD'].includes(kind);
export const broadcastEventDuration = (kind: string, recordedAt: number, now = Date.now()) => kind === 'TEAM_TIMEOUT'
  ? Math.max(0, 60000 - (now - recordedAt)) : kind === 'GOAL' || kind === 'PENALTY_GOAL' ? 10000 : 8000;

export const broadcastClock = (ms: number, mode: 'remaining' | 'elapsed' = 'remaining') => {
  const seconds = Math.max(0, mode === 'elapsed' ? Math.floor(ms / 1000) : Math.ceil(ms / 1000));
  return `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
};

export const broadcastEventKind = (event?: MatchOperationsEvent) => {
  if (event?.type !== 'SHOT_ATTEMPT_RECORDED') return event?.type || '';
  if (event.shotOutcome === 'GOAL') return event.shotType === 'SEVEN_METER' ? 'PENALTY_GOAL' : 'GOAL';
  if (event.shotOutcome === 'SAVED') return 'SHOT_SAVED';
  if (event.shotOutcome === 'MISSED') return event.shotType === 'SEVEN_METER' ? 'MISSED_7M' : 'SHOT_MISSED';
  if (event.shotOutcome === 'POST') return 'SHOT_POST';
  if (event.shotOutcome === 'BLOCKED') return 'SHOT_BLOCKED';
  return '';
};

export const isFreshBroadcastEvent = (event: MatchOperationsEvent, now = Date.now()) => {
  const age = now - (event.serverTimestamp?.getTime() ?? 0);
  return age >= -5000 && age < (event.type === 'TEAM_TIMEOUT' ? 60000 : 20000);
};
